var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / news_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-news_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "news",
    transform: "translate(6.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5,1.5 L76.5,50 C76.5,50.9664983 76.1082492,51.8414983 75.4748737,52.4748737 C74.8414983,53.1082492 73.9664983,53.5 73,53.5 L73,53.5 L11.5,53.5 L11.5,1.5 L76.5,1.5 Z",
    id: "Back---Border",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,8 L67,8 C67.5522847,8 68,8.44771525 68,9 L68,46.7002777 L68,46.7002777 C68.2561506,50.7334259 69.8394839,52.75 72.75,52.75 C72.75,52.75 72.75,53.5 72.75,55 L5,55 C2.23857625,55 -4.30428357e-13,52.7614237 -4.33431069e-13,50 L-4.33431069e-13,9 C-4.33498704e-13,8.44771525 0.44771525,8 1,8 Z",
    id: "Front---Fill",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5,9.5 L66.5,46.7468087 C66.6475707,49.1757087 67.2561156,50.9619739 68.1998178,52.1638974 C68.6273328,52.7083915 69.1240407,53.1510667 69.6929145,53.4862591 L69.717,53.5 L5,53.5 C4.10784771,53.5 3.29365848,53.1662005 2.67551069,52.6166798 L2.52512627,52.4748737 C1.89175084,51.8414983 1.5,50.9664983 1.5,50 L1.5,50 L1.5,9.5 L66.5,9.5 Z",
    id: "Front---Border",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Form---Fill",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#202020",
    fillRule: "nonzero",
    x: 9,
    y: 26.75,
    width: 18,
    height: 20.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Line---Fill",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#202020",
    fillRule: "nonzero",
    x: 33,
    y: 40.75,
    width: 27,
    height: 6.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Line---Fill",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#202020",
    fillRule: "nonzero",
    x: 33,
    y: 27.75,
    width: 27,
    height: 6.5,
    rx: 3.13008131
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Headline---Fill",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#202020",
    fillRule: "nonzero",
    x: 8,
    y: 14.75,
    width: 52,
    height: 6.5,
    rx: 3.13008131
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsAppTile);
export default __webpack_public_path__ + "static/media/news_app_tile.61f1acbc41fded354fe062973708d814.svg";
export { ForwardRef as ReactComponent };